import templateStr from 'text!./gateway-dashboard.html';
import _ from 'underscore';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            selectedProducerCode: '='
        },
        controller: ['$scope', '$state', 'JobService', 'AccountService', 'gatewayParamConfig', 'PolicyService', function ($scope, $state, JobService, AccountService, gatewayParamConfig, PolicyService) {
            init();

            function init() {
                console.log("gateway dashboard init");
                if ($scope.selectedProducerCode === undefined) {
                    $scope.selectedProducerCode = 'all';
                }

                PolicyService.callEUTS('Landing Page Partner Connect', 'Page Viewed', '?', 'Partner Connect Access');

                //DEF1903-Performance-UI-Portal-PE-Repeated Calls in the same request - identified in Performance Test
                /*PolicyService.getDisplayName().then(function (userdetails) {
                        console.log(userdetails);
                        $scope.userResultsPromise = userdetails.fullName;
                        if (userdetails.fullName) $scope.fullName = userdetails.fullName;
                        if (userdetails.userType) $scope.userType = userdetails.userType;
                        if (userdetails.emailAddress) $scope.emailAddress = userdetails.emailAddress;
                        if (userdetails.primaryPhoneNumber) $scope.primaryPhoneNumber = userdetails.primaryPhoneNumber;
                        if (userdetails.city) $scope.city = userdetails.city;
                    });*/
            }

            function refreshJobs(aProducerCode) {
                var obj = _.find($scope.summaries, { producerCode: aProducerCode });
                if (obj != undefined) {
                    $scope.numberOfOpenQuotes = obj.openSubmissions;
                    $scope.numberOfOpenRenewals = obj.openRenewals;
                    $scope.numberOfOpenPolicyChanges = obj.openPolicyChanges;
                    $scope.numberOfOpenCancellations = obj.openCancellations;
                };
            }

            /**
            * Call PolicyCenter to retrieve the accounts jobs for the current user
            * @returns {Promise} the accounts jobs for the current user
            */
            function getAccountJobsSummaryForCurrentUser() {
                if (!("all" === $scope.selectedProducerCode.code || "myWork" === $scope.selectedProducerCode.code)) {
                    return AccountService.getAccountJobsSummariesForCurrentUser(gatewayParamConfig.jobsCreatedInLastXDays, $scope.selectedProducerCode.code);
                }
                return AccountService.getAccountJobsSummariesForCurrentUser(gatewayParamConfig.jobsCreatedInLastXDays, undefined);
            }

            function filterAccountJobSummaries(summaries) {
                $scope.accountJobsSummary = _.find(summaries, function (summary) {
                    return filterSummaryByProducerCode(summary);
                });
            }

            function filterSummaryByProducerCode(summary) {
                refreshJobs(summary.producerCode);
                return angular.isDefined(summary.producerCode) && summary.producerCode === $scope.selectedProducerCode.code;
            }

            $scope.$watch('selectedProducerCode', function (oldvalue, newvalue) {
                if (oldvalue != newvalue && angular.isDefined($scope.selectedProducerCode)) {
                    getAccountJobsSummaryForCurrentUser().then(function (producerSummaries) {
                        $scope.summaries = producerSummaries;
                        refreshJobs($scope.selectedProducerCode.code);

                        filterAccountJobSummaries(producerSummaries);
                        $scope.$emit('dashboardTilesLoaded');
                    });
                }
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/GatewayDashboardDirective/GatewayDashboard.js
// module id = 1743
// module chunks = 0